import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hma3kre8ec: FaireBrandEntity = {
  token: "b_hma3kre8ec",
  type: "brand",
  name: "Heritage Valley Goods",
  avatarUrl:
    "https://cdn.faire.com/fastly/a3939083eeaabefbe68252ade1a8e7b6662d40c4aaba7cc10c955f8b3d8abe9f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/dff37771a9ef01f7ee6007247fb4056a591427f8f7fdd0ec78670046126786d4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a3939083eeaabefbe68252ade1a8e7b6662d40c4aaba7cc10c955f8b3d8abe9f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dff37771a9ef01f7ee6007247fb4056a591427f8f7fdd0ec78670046126786d4.jpeg",
  location: "Santa Paula, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 8,
  isTopShop: true,
  isInsider: true,
  description:
    "Since 2018, Heritage Valley Goods has been bringing a fresh, homely character to every room one of our candles are burned in. \n\nWe started by selling candles made on our stove in small local markets, but have invested and built a small brand that seeks to bring small town care & quality to shops, businesses & homes of all sizes.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:10.573Z",
    importedBy: "entity-db-cli",
  },
};
